import { WizardPrices } from './enums/prices'

export const pricesMap = {
  [WizardPrices.Lte3000]: { from: 0, to: 3000 },
  [WizardPrices.Gte3000lte5000]: { from: 3000, to: 5000 },
  [WizardPrices.Gte5000lte7000]: { from: 5000, to: 7000 },
  [WizardPrices.Gte7000lte10000]: { from: 7000, to: 10000 }
}
